import { render } from "./TheSidebarMenu.vue?vue&type=template&id=397291fa&scoped=true"
import script from "./TheSidebarMenu.vue?vue&type=script&lang=js"
export * from "./TheSidebarMenu.vue?vue&type=script&lang=js"

import "./TheSidebarMenu.vue?vue&type=style&index=0&id=397291fa&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397291fa"]])

export default __exports__